/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import styles from '../InviteTeamMember.module.css';
import TwoColumnContent from '../../../components/TwoColumnContent/TwoColumnContent';
import LeftColumn from '../../../components/TwoColumnContent/LeftColumn/LeftColumn';
import TitleDescription from '../../../components/TitleDescription/TitleDescription';
import RightColumn from '../../../components/TwoColumnContent/RightColumn/RightColumn';
import { AdminInput } from '@project/components';
import UsersPropertyRolesList from '../../../components/UsersPropertyRolesList/UsersPropertyRolesList';
import { useIntl } from 'react-intl';
import { useFormContext } from 'react-hook-form';
import { useFilteredProperties } from '../../../utils/hooks';
import { useActiveProperties } from '../hooks/useActiveProperties';

export const TeamMemberProperties = props => {
  const [filter, setFilter] = useState('');


  const intl = useIntl();
  const t = id => intl.formatMessage({ id });

  const form = useFormContext();

  const isCompanyAdmin = form.watch('isCompanyAdmin');
  const globalAccess = form.watch('globalAccess');
  const allSelected = form.watch('allSelected');
  const company = form.watch('company');
  const companyRole = form.watch('companyRole');

  const {data: properties} = useActiveProperties(company, companyRole);
  const [filteredProperties] = useFilteredProperties({ filter, properties });
  form.setValue('properties', properties);

  useEffect(() => {
    if (companyRole && properties) {
      const updatedProperties = properties?.map(p => ({
        ...p,
        roleId: companyRole.value
      }));
      form.setValue('properties', updatedProperties);
      selectAll(companyRole.value, true);
    }
  }, [companyRole]);

  const onPropertyRoleChange = (event, index, roleId) => {
    filteredProperties[index].roleId = roleId;
    form.setValue('properties', [...properties]);
  };

  const selectAll = (roleId, all) => {
    filteredProperties.forEach(p => {
      p.roleId = all ? roleId : null;
    });
    form.setValue('properties', [...properties]);
    const allSelected = form.watch('allSelected');
    let sel = { ...allSelected };
    Object.keys(sel).forEach(key => {
      sel[key] = all ? key === roleId : false;
    });

    form.setValue('allSelected', sel);
  };

  return (
    <>
      {/* GLOBAL PROPERTY CHECKBOX */}
      <TwoColumnContent bottomBorder={true}>
        <LeftColumn>
          <TitleDescription
            title={t('InviteTeamMember.globalAccess.title')}
            description={t('InviteTeamMember.globalAccess.desc')}
          />
        </LeftColumn>
        <RightColumn>
          <div className={`${styles.checkInput} ${styles.mfa} d-flex align-items-center`}>
            <label htmlFor="has-global-access" className="m-0">
              {t('InviteTeamMember.globalAccess.label')}
            </label>
            <input
              style={{ marginLeft: '20px' }}
              id={'has-global-access'}
              type="checkbox"
              checked={globalAccess}
              disabled={isCompanyAdmin}
              onChange={e => form.setValue('globalAccess', e.target.checked)}
            />
          </div>
        </RightColumn>
      </TwoColumnContent>

      {/* PROPERTY TABLE */}
      <TwoColumnContent className="pb-4">
        <LeftColumn>
          <TitleDescription
            title={t('InviteTeamMember.propertyRole.title')}
            description={t('InviteTeamMember.propertyRole.details')}
          />
        </LeftColumn>
        <RightColumn padded={true}>
          {!globalAccess ? (
            <div className="pl-2">
              <AdminInput
                id="role"
                label={t('InviteTeamMember.propertyRole.label')}
                type="text"
                placeholder={t('InviteTeamMember.propertyRole.placeholder')}
                value={filter}
                onChange={e => setFilter(e.target.value)}
              />
              <UsersPropertyRolesList
                properties={filteredProperties}
                allSelectedViewer={allSelected.viewer}
                allSelectedEditor={allSelected.editor}
                allSelectedDesigner={allSelected.designer}
                onPropertyRoleChange={onPropertyRoleChange}
                selectAll={selectAll}
                globalAccess={globalAccess}
              />
            </div>
          ) : (
            <div className="pl-2">{t('InviteTeamMember.globalAccess.disable')}</div>
          )}
        </RightColumn>
      </TwoColumnContent>
    </>
  );
};
